export type IndustryKey = 'proizvodnja';

export type IndustryPageCopy = {
  metadata: { title: string; description: string };
  hero: {
    eyebrow: string;
    title: string;
    subtitle: string;
    bullets: string[];
  };
  sections: { title: string; body: string }[];
  finalCta: { title: string; body: string; button: string };
};

const sr: Record<IndustryKey, IndustryPageCopy> = {
  proizvodnja: {
    metadata: {
      title: 'Cadrino ERV za proizvodnju, prisustvo, pristup i uređaji',
      description:
        'Operativni pregled za pogone, smene i uređaje, bez Excela i nagađanja na kraju meseca.',
    },
    hero: {
      eyebrow: 'Proizvodnja',
      title: 'Više pogona. Jedan jasan pregled.',
      subtitle:
        'Smene, ulazi i uređaji traže red i tačnost. Cadrino ERV daje operativnu kontrolu koju HR, operativa i rukovodstvo gledaju zajedno.',
      bullets: [
        'ko sme u koji pogon ili ulaz',
        'status uređaja pre smene',
        'šta je zabeleženo i šta čeka obradu',
      ],
    },
    sections: [
      {
        title: 'Pre smene znate da li sve radi',
        body:
          'Kad uređaj nije povezan ili događaj čeka obradu, problem se ne sme otkriti tek na obračunu. Pregled mora biti jasan svakog dana.',
      },
      {
        title: 'Pravila po lokaciji, ne nagađanje',
        body:
          'Hala, magacin i kancelarija mogu imati različita pravila pristupa. Sistem ih drži na jednom mestu, uz jasnu dodelu po uređaju.',
      },
    ],
    finalCta: {
      title: 'Pogon koji vam liči na demo?',
      body: 'Prođimo vaše smene, ulaze i uređaje na razgovoru od 30 minuta.',
      button: 'Zakažite demo',
    },
  },
};

const en: Record<IndustryKey, IndustryPageCopy> = {
  proizvodnja: {
    metadata: {
      title: 'Cadrino ERV for manufacturing, attendance, access, devices',
      description:
        'Operational visibility for plants, shifts, and devices, without month-end spreadsheet chaos.',
    },
    hero: {
      eyebrow: 'Manufacturing',
      title: 'Multiple halls. One clear view.',
      subtitle:
        'Shifts, entrances, and devices need order and accuracy. Cadrino ERV gives operational control HR, operations, and leadership share.',
      bullets: [
        'who may enter which hall or gate',
        'device status before the shift',
        'what was recorded and what is waiting',
      ],
    },
    sections: [
      {
        title: 'Know before the shift starts',
        body:
          'When a device is offline or an event is waiting, the issue must not surface only at payroll. The view must be clear every day.',
      },
      {
        title: 'Rules per site, not guesswork',
        body:
          'Plant, warehouse, and office can have different access rules. The system holds them in one place with clear per-device assignment.',
      },
    ],
    finalCta: {
      title: 'A plant like yours on demo?',
      body: 'We walk through your shifts, gates, and devices in a 30-minute call.',
      button: 'Book a demo',
    },
  },
};

export const industryCopy = { sr, en };

export function getIndustryCopy(key: IndustryKey, language: string): IndustryPageCopy {
  return industryCopy[language === 'en' ? 'en' : 'sr'][key];
}
